/**
 * Created by pbo on 23/09/16.
 */
angular.module('taric.auth.model', ['ngResource', 'common.config']).factory('Authorize', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/secure/user', {}, {
        getUser: {
            method: 'GET',
            isArray: false
        }
    });
}).service('AuthorizeModel', function($rootScope, $q, Authorize, $window){
    var model = this;

    model.init = function() {
        model.user = null;
        model.userName = null;
        model.password = null;
        model.jwt = null;
        model.roles = null;

        model.loggedIn = false;
    };

    model.logout = function(){
        model.init();
    };


    // Initialize first time
    model.init();

    model.getUser = function() {
        var deferred = $q.defer();
        Authorize.getUser(function (result) {
            deferred.resolve(result);
        }, function(error) {

        });
        return deferred.promise;
    };

    model.isIncludedUnreleasedDataViewer = function() {
        if (model.roles) {
            return model.roles.includes('taUnreleasedDataViewer');
        } else {
            return false;
        }
    };

});



// WEBPACK FOOTER //
// ./app/taric/auth/model.js